import { Observance, ObservanceAPI } from "./observance";

export class Telesuivi {
    observanceList?: Observance[];

    constructor(observanceList?: Observance[]) {
        this.observanceList = observanceList;
    }

    static factory(telesuiviAPI: TelesuiviAPI): Telesuivi {
        return new Telesuivi(
            telesuiviAPI.Observances.Observance instanceof Array
                ? telesuiviAPI.Observances.Observance.map(
                    (observanceAPI: ObservanceAPI) => Observance.factory(observanceAPI)
                )
                : telesuiviAPI.Observances.Observance
                    ? [Observance.factory(telesuiviAPI.Observances.Observance)]
                    : undefined,
        )
    }
}

export type TelesuiviAPI = {
    Observances: {
        Observance: ObservanceAPI[] | ObservanceAPI;
    };
};


